<template>
  <v-snackbar v-model="snackbar" :color="snackbarColor" :top="true">
    {{ snackbarMessage }}
    <v-btn dark text @click="snackbarHide">
      Close
    </v-btn>
  </v-snackbar>
</template>
<script>
import EventBus from "@/config/bus";

export default {
  data() {
    return {
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: ""
    };
  },
  mounted() {
    EventBus.$on("SNACKBAR_SHOW", ({ message, color }) => {
      this.snackbar = true;
      this.snackbarMessage = message;
      this.snackbarColor = color;
    });
    EventBus.$on("SNACKBAR_HIDE", () => {
      this.snackbar = false;
      this.snackbarMessage = "";
      this.snackbarColor = "";
    });
  },
  methods: {
    snackbarHide() {
      EventBus.$emit("SNACKBAR_HIDE");
    }
  }
};
</script>
